// extracted by mini-css-extract-plugin
export default {"description":"AuthNav_description__Uf3Zq","btnsList":"AuthNav_btnsList__w0YfR","btn":"AuthNav_btn__ZIim0","btnWhite":"AuthNav_btnWhite__VNT+G","div":"AuthNav_div__2ThI8"};